import { useCallback } from "react";
import { useLongPressContextMenu } from "../../hooks/useLongPressContextMenu.js";

/**
 * Unified list row: bar + optional avatar + body (title, right, bottom) + arrow.
 * Use for deals, clients, tasks, dialogs, reports.
 */
export function CrmRow({
  barClass = "good",
  avatar,
  title,
  right,
  bottom,
  onClick,
  onContextMenu,
  className = "",
  arrow = true,
  disabled,
  style,
  children,
  /** Подсказка браузера (атрибут title), напр. для недоступных строк */
  nativeTitle,
}) {
  const { handlers: longPressHandlers, consumeClickIfSuppressed } = useLongPressContextMenu(
    !disabled && onContextMenu ? onContextMenu : null
  );

  const handleRowClick = useCallback(
    (e) => {
      if (consumeClickIfSuppressed()) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      onClick?.(e);
    },
    [onClick, consumeClickIfSuppressed]
  );

  const extraClass = avatar ? " crmRowWithAvatar" : "";
  const combinedStyle = { ...(disabled ? { pointerEvents: "none" } : {}), ...style };
  return (
    <div
      role={onClick && !disabled ? "button" : undefined}
      tabIndex={onClick && !disabled ? 0 : undefined}
      className={`crmRow${extraClass} ${className}`.trim()}
      style={Object.keys(combinedStyle).length ? combinedStyle : undefined}
      title={nativeTitle}
      onClick={disabled ? undefined : onClick ? handleRowClick : undefined}
      {...(!disabled && onContextMenu ? longPressHandlers : {})}
    >
      <span className={`crmRowBar ${barClass}`} aria-hidden="true" />
      {avatar != null ? (typeof avatar === "string" ? <span className="avatar" aria-hidden="true">{avatar}</span> : avatar) : null}
      <div className="crmRowBody">
        <div className="crmRowTop">
          <div className="crmRowTitle">{title}</div>
          {right != null ? <div className="crmRowRight">{right}</div> : null}
        </div>
        {bottom != null ? <div className="crmRowBottom">{bottom}</div> : null}
        {children}
      </div>
      {arrow ? <span className="rowArrow">›</span> : null}
    </div>
  );
}
